import { createContext, ReactNode, useContext } from "react"

const MaxWidthContext = createContext<{
    maxWidth: string
}>({ maxWidth: "" })

export const MaxWidthProvider = ({ children }: { children: ReactNode }) => {
    const maxWidth = "90cqw"

    return <MaxWidthContext.Provider value={{ maxWidth }}>{children}</MaxWidthContext.Provider>
}

export const useMaxWidthContext = () => {
    const { maxWidth } = useContext(MaxWidthContext)
    return { maxWidth }
}
